var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlLocation24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/Control/Location24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "iconLocation",
    transform: "translate(3.000000, 1.000000)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2232588,13.9209283 C14.6078234,13.3664725 14.9282072,12.8205669 15.21485,12.2251609 C15.7283715,11.2382022 16,10.1407973 16,9 C16,5.13400675 12.8659932,2 9,2 C5.13400675,2 2,5.13400675 2,9 C2,10.1290257 2.26603721,11.2155719 2.76943835,12.1947823 L2.79744979,12.2514551 C3.05730311,12.7988018 3.38269488,13.355343 3.77492103,13.9206144 C4.88089355,15.5145279 6.62428726,17.3614438 9.00006099,19.4400999 C11.3740186,17.3630613 13.1167374,15.5162836 14.2232588,13.9209283 Z M0,9 C0,4.02943725 4.02943725,0 9,0 C13.9705627,0 18,4.02943725 18,9 C18,10.4960987 17.6349488,11.906935 16.9890607,13.148295 C16.6844942,13.7835597 16.3103596,14.421052 15.8666568,15.0607717 C14.4516982,17.1008241 12.1628126,19.4366275 9,22.068182 C5.83529186,19.4346032 3.54587213,17.0987997 2.13174081,15.0607717 C1.67889277,14.4081329 1.29855261,13.7576094 0.99072034,13.1092014 C0.357437944,11.8773473 0,10.4804157 0,9 Z M9,13 C6.790861,13 5,11.209139 5,9 C5,6.790861 6.790861,5 9,5 C11.209139,5 13,6.790861 13,9 C13,11.209139 11.209139,13 9,13 Z M9,11 C10.1045695,11 11,10.1045695 11,9 C11,7.8954305 10.1045695,7 9,7 C7.8954305,7 7,7.8954305 7,9 C7,10.1045695 7.8954305,11 9,11 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlLocation24);
export default __webpack_public_path__ + "static/media/controlLocation24.2b045ae4ca7a04a73a8a267302411fe0.svg";
export { ForwardRef as ReactComponent };